"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Card_1 = require("@material-ui/core/Card");
var Grid_1 = require("@material-ui/core/Grid");
var Link_1 = require("@material-ui/core/Link");
var Tooltip_1 = require("@material-ui/core/Tooltip");
var Typography_1 = require("@material-ui/core/Typography");
var withStyles_1 = require("@material-ui/styles/withStyles");
var graphql_tag_1 = require("graphql-tag");
var Env_1 = require("src/Env");
var styles_1 = require("./styles");
exports.BookCardFragmentGQL = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment BookCardFragment on Book {\n    id\n    projectId\n    imageUrl\n    title\n    displaySubtitle\n    blackouts {\n      endDate\n      startDate\n      bookAccessCuttoff\n    }\n  }\n"], ["\n  fragment BookCardFragment on Book {\n    id\n    projectId\n    imageUrl\n    title\n    displaySubtitle\n    blackouts {\n      endDate\n      startDate\n      bookAccessCuttoff\n    }\n  }\n"])));
var ToolTipOrFragment = function (props) {
    if (!props.title) {
        return React.createElement(React.Fragment, null, props.children);
    }
    return (React.createElement(Tooltip_1.default, { title: props.title, placement: "top" }, props.children));
};
var BookshelfCard = function (props) {
    var book = props.book, classes = props.classes, blackout = props.blackout;
    var title = book.title, imageUrl = book.imageUrl, displaySubtitle = book.displaySubtitle, projectId = book.projectId;
    var readerLink = projectId === null ? undefined : Env_1.READER_URL + "#/read/" + projectId + "/";
    var linkHref = blackout === null ? readerLink : undefined;
    var toolTipText = blackout === null ? undefined : 'Temporarily Unavailable';
    var style = blackout === null ? {} : { opacity: .5 };
    return (React.createElement(Grid_1.default, { item: true, style: style },
        React.createElement(Link_1.default, { href: linkHref, target: "blank", className: classes.bookshelfCardLink },
            React.createElement(ToolTipOrFragment, { title: toolTipText },
                React.createElement(Card_1.default, { className: classes.productCard },
                    React.createElement("div", { style: { height: 330, overflow: 'hidden' } }, imageUrl && React.createElement("img", { src: imageUrl, alt: title || '', style: { width: '100%' } })),
                    React.createElement(Grid_1.default, { container: true, direction: "column", className: classes.infoBlock },
                        React.createElement(Grid_1.default, { item: true },
                            React.createElement(Typography_1.default, { className: classes.productName, variant: "h6" }, title)),
                        React.createElement(Grid_1.default, { item: true, className: classes.courseOrAuthor },
                            React.createElement(Typography_1.default, { variant: "subtitle2" }, displaySubtitle))))))));
};
exports.default = withStyles_1.default(styles_1.default)(BookshelfCard);
var templateObject_1;
